/* eslint-disable eqeqeq */
import React from 'react';
import { container } from 'tsyringe';
import { KabupatenPresenter } from '../../../../../../data/presenters/KabupatenPresenter';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Kabupaten } from '../../../../../../entities/Kabupaten';
import { Provinsi } from '../../../../../../entities/Provinsi';
import { ProvinsiPresenter } from '../../../../../../data/presenters/ProvinsiPresenter';
import {
  getCache,
  setCache,
  CACHE_KEYS,
  CACHE_TTL,
} from '../../../../../../app/misc/CacheStorage';

interface IState {
  isLoading: boolean;
  jumlahPage: number;
  page: number;
  keyword: string;
  row: number;
  totalKabupaten: number;
  kabupaten: Kabupaten[];
  provinsi: Provinsi[];
  formId: number;
  formDialog: string;
  formProvinsiId: string;
  formNameKabupaten: string;
  formLoading: boolean;
  showDialog: boolean;
  showDialogDelete: boolean;
}

interface InitialState {
  state: IState;
  getKabupaten: Function;
  setPage: Function;
  setPageRow: Function;
  searchKabupaten: Function;
  setFormDialog: Function;
  setUpdate: Function;
  actionFormDialog: Function;
  setFormProvinsiId: Function;
  setFormNameKabupaten: Function;
  setShowDialog: Function;
  setShowDialogDelete: Function;
  deleteKabupaten: Function;
  getProvinsi: Function;
}

const initialState = {
  state: {
    isLoading: true,
    jumlahPage: 0,
    page: 1,
    keyword: '',
    row: 10,
    totalKabupaten: 1,
    kabupaten: [],
    provinsi: [],
    formDialog: '',
    formId: 0,
    formProvinsiId: '',
    formNameKabupaten: '',
    formLoading: false,
    showDialog: false,
    showDialogDelete: false,
  },
  getKabupaten: () => {},
  searchKabupaten: () => {},
  setPage: () => {},
  setPageRow: () => {},
  setFormDialog: () => {},
  setUpdate: () => {},
  actionFormDialog: () => {},
  setFormProvinsiId: () => {},
  setFormNameKabupaten: () => {},
  setShowDialog: () => {},
  deleteKabupaten: () => {},
  setShowDialogDelete: () => {},
  getProvinsi: () => {},
};
const Context = React.createContext<InitialState>(initialState);
const { Provider: MasterKabupatenProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({
    isLoading: false,
    jumlahPage: 0,
    page: 1,
    keyword: '',
    row: 10,
    totalKabupaten: 0,
    kabupaten: [],
    provinsi: [],
    formDialog: '',
    formId: 0,
    formProvinsiId: '',
    formNameKabupaten: '',
    formLoading: false,
    showDialog: false,
    showDialogDelete: false,
  });

  const setLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoading: value,
    }));
  };

  const setPage = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      page: value,
    }));
  };

  const setPageRow = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      row: value,
    }));
  };

  const setJumlahPage = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      jumlahPage: value,
    }));
  };

  const getKabupaten = async (pagee: number, keyword: string, row: number) => {
    setLoading(true);

    try {
      const kabupatenPresenter = container.resolve(KabupatenPresenter);
      const getAllKabupaten = await kabupatenPresenter.getAllKabupaten(
        pagee,
        row,
        keyword
      );

      const data = getAllKabupaten;

      if (!data || data.length === 0) {
        setState((prevstate) => ({
          ...prevstate,
          kabupaten: [],
          jumlahPage: 0,
        }));
      } else {
        setJumlahPage(data[0].jumlahData / row);
        setState((prevstate) => ({
          ...prevstate,
          kabupaten: data,
        }));
      }

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const searchDebounceRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  
  const searchKabupaten = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      keyword: value,
    }));
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    searchDebounceRef.current = setTimeout(() => {
      getKabupaten(1, value, state.row);
    }, 500);

  };

  const setFormDialog = (value: string) => {
    clearForm();
    setState((prevstate) => ({
      ...prevstate,
      formDialog: value,
    }));
  };

  const setUpdate = (value: Kabupaten) => {
    setState((prevstate) => ({
      ...prevstate,
      formId: value.id,
      formProvinsiId: value.provinsi_id.toString(),
      formNameKabupaten: value.nama_kabupaten,
    }));
  };

  const setFormLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      formLoading: value,
    }));
  };

  const actionFormDialog = async () => {
    setFormLoading(true);

    if (state.formNameKabupaten == '') {
      toast.error('Data Belum Terisi Lengkap!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
      return;
    }

    try {
      const kabupatenPresenter = container.resolve(KabupatenPresenter);
      if (state.formDialog == 'Tambah') {
        const action = await kabupatenPresenter.createKabupaten(
          state.formProvinsiId,
          state.formNameKabupaten
        );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialog(false);
          getKabupaten(state.page, state.keyword, state.row);
          clearForm();
        } else {
          toast.error('Ada Kesalahan Saat Tambah Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      } else if (state.formDialog == 'Ubah') {
        const action = await kabupatenPresenter.updateKabupaten(
          state.formId,
          state.formProvinsiId,
          state.formNameKabupaten
        );
        const data = action;

        setFormLoading(false);

        if (data.data.code == 200) {
          toast.success(data.data.message, {
            style: {
              boxShadow: '0px 1px 6px #019166',
            },
          });
          setShowDialog(false);
          getKabupaten(state.page, state.keyword, state.row);
          clearForm();
        } else {
          toast.error('Ada Kesalahan Saat Ubah Data!', {
            style: {
              boxShadow: '0px 1px 6px #F86E70',
            },
          });
        }
      }
    } catch (error: any) {
      setFormLoading(false);
      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const setFormProvinsiId = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formProvinsiId: value,
    }));
  };

  const setFormNameKabupaten = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formNameKabupaten: value,
    }));
  };

  const setShowDialog = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialog: value,
    }));
  };

  const clearForm = () => {
    setState((prevstate) => ({
      ...prevstate,
      formId: 0,
      formProvinsiId: '',
      formNameKabupaten: '',
    }));
  };

  const deleteKabupaten = async () => {
    setFormLoading(true);

    try {
      const kabupatenPresenter = container.resolve(KabupatenPresenter);
      const action = await kabupatenPresenter.deleteKabupaten(state.formId);
      const data = action;

      setFormLoading(false);

      if (data.data.code == 200) {
        toast.success(data.data.message, {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        setShowDialogDelete(false);
        getKabupaten(state.page, state.keyword, state.row);
        clearForm();
      } else {
        toast.error('Ada Kesalahan Saat Hapus Data!', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
      }
    } catch (error: any) {
      setFormLoading(false);

      toast.error('Ada Kesalahan, Silahkan Coba Lagi!', {
        style: {
          boxShadow: '0px 1px 6px #F86E70',
        },
      });
    }
  };

  const setShowDialogDelete = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogDelete: value,
    }));
  };

  const getProvinsi = async () => {
    const cached = getCache<Provinsi[]>(CACHE_KEYS.LIST_PROVINSI);
    if (cached) {
      setState((prevstate) => ({ ...prevstate, provinsi: cached }));
      return;
    }

    setLoading(true);

    try {
      const provinsiPresenter = container.resolve(ProvinsiPresenter);
      const getAllProvinsi = await provinsiPresenter.getAllProvinsi(
        1,
        100000000,
        ''
      );

      const data = getAllProvinsi;

      setCache(CACHE_KEYS.LIST_PROVINSI, data, CACHE_TTL.MASTER_DATA);
      setState((prevstate) => ({
        ...prevstate,
        provinsi: data,
      }));
      setLoading(false);
    } catch (error: any) {
      console.log('error provinsi:', error);
      setLoading(false);
    }
  };

  return (
    <MasterKabupatenProvider
      value={{
        state,
        getKabupaten,
        setPage,
        setPageRow,
        searchKabupaten,
        setFormDialog,
        setUpdate,
        actionFormDialog,
        setFormProvinsiId,
        setFormNameKabupaten,
        setShowDialog,
        deleteKabupaten,
        setShowDialogDelete,
        getProvinsi,
      }}
    >
      {children}
    </MasterKabupatenProvider>
  );
};

export const useMasterKabupatenContext = () => React.useContext(Context);
// eslint-disable-next-line
export default {
  useMasterKabupatenContext,
  Provider,
};
